import { useState } from "react";
import { motion } from "framer-motion";
import placeholderImg from "../../assets/placeholder-image-two.jpg";

export default function RecipeCard({ item }) {
  const [hovered, setHovered] = useState(false);

  const images = item?.images || [];
  const mainImg = images[0] || placeholderImg;
  const thumbs = Array.from(
    { length: 4 },
    (_, i) => images[i + 1] || placeholderImg,
  );

  return (
    <a
      href={`/recipe-details/${item?._id}`}
      style={{ textDecoration: "none", color: "inherit", display: "block" }}
    >
      <motion.div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        transition={{ duration: 0.3 }}
        style={{
          width: "100%",
          backgroundColor: "#f0f0f3",
          borderRadius: 12,
          overflow: "hidden",
          cursor: "pointer",
          boxShadow: hovered ? "0 6px 20px rgba(0,0,0,0.1)" : "none",
          transition: "box-shadow 0.25s",
        }}
      >
        {/* Main image */}
        <div
          style={{
            width: "100%",
            overflow: "hidden",
            backgroundColor: "#f8f9fa",
          }}
        >
          <motion.img
            src={mainImg}
            alt={item?.title || "Recipe"}
            animate={{
              scale: hovered ? 1.02 : 1,
              filter: hovered ? "brightness(1.05)" : "brightness(1)",
            }}
            transition={{ duration: 0.4 }}
            style={{
              width: "100%",
              height: 150,
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>

        {/* Thumbnail row */}
        <div className="d-flex" style={{ margin: 0 }}>
          {thumbs.map((img, i) => (
            <div key={i} style={{ flex: 1 }}>
              <img
                src={img}
                alt=""
                style={{
                  width: "100%",
                  height: 42,
                  objectFit: "cover",
                  border: "2px solid #f1f1f1",
                  borderRadius: 4,
                  display: "block",
                }}
              />
            </div>
          ))}
        </div>

        {/* Info */}
        <div style={{ padding: "8px 10px 10px" }}>
          <h6
            style={{
              fontSize: 13,
              fontWeight: 700,
              fontFamily: "'Inter', sans-serif",
              color: "#222",
              marginBottom: 4,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item?.title || "Recipe Title"}
          </h6>

          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            <img
              src={item?.kitchenId?.kitchenLogo || placeholderImg}
              alt={item?.kitchenId?.name}
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <span
              style={{
                fontSize: 11,
                color: "#6b7280",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              By {item?.kitchenId?.name || "Chef"}
            </span>
          </div>
        </div>
      </motion.div>
    </a>
  );
}
